import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_PATIENT_RESOURCES_BY_ID_KEY } from '_api/queries/resource/useGetAllPatientResourcesByID';
import { GET_ALL_RESOURCES_KEY } from '_api/queries/resource/useGetAllResources';

export const DELETE_RESOURCE_SETTING_BY_ID_KEY = 'delete-resource-setting-by-id';

export const useDeleteResourceSettingById = () => {
  const queryClient = useQueryClient();

  return useApiMutation<{}, { id: number }>(
    ({ id }) => `/resource/patient-resource/${id}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_RESOURCE_SETTING_BY_ID_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_RESOURCES_KEY] });
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_RESOURCES_BY_ID_KEY],
        });
      },
    },
  );
};
